import { GiftcardService } from '@/api/giftcard'
import { Button } from '@/cn/ui/button'
import { CopyButton } from '@/ui'
import SpinnerLoader from '@/ui/spinner_loader'
import { localizeFiat, share, SHOW } from '@/utils'
import { useQuery } from '@tanstack/react-query'
import { Share2 } from 'lucide-react'
import { Link } from 'react-router-dom'

const GiftCards = () => {
  const giftcards = useQuery({ queryKey: ['gift-cards'], queryFn: () => GiftcardService.GetAll() })
  if (giftcards.isLoading) return <SpinnerLoader />
  return (
    <div className="flex flex-col flex-grow overflow-auto">
      <Button asChild className="my-4">
        <Link to={'claim'}>Claim a Gift Card</Link>
      </Button>
      <div className="flex flex-col gap-3 flex-grow overflow-scroll mb-12">
        {/* <span className="mt-2">Your Gift Cards</span> */}
        <div {...SHOW(!giftcards.data?.result?.length)} className="flex items-center justify-center">
          <h3>No Giftcard found</h3>
        </div>
        {giftcards.data?.result?.map((giftcard: any) => (
          <div className="flex flex-col items-center justify-center border overflow-hidden border-gray-200 w-full rounded-2xl shadow-lg h-48">
            <div className="flex-grow flex items-center justify-center p-4">
              <img src="/cray-logo.png" className="w-24 " />
            </div>
            <div className="bg-white w-full py-2 px-4 flex items-center justify-between border-t border-gray-200">
              <div>
                <h6 className="font-bold">Gift Card</h6>
                <span>
                  {localizeFiat(giftcard.amount)}
                  {/* {ACTIVE_CURRENCY.symbol} {String(Number(giftcard.amount) / ACTIVE_CURRENCY.conversion_rate)} */}
                </span>
              </div>
              <div className="flex items-center gap-4">
                {giftcard.claimed ? (
                  <span className="px-4 py-1 rounded-md bg-primary/30 text-primary">Claimed</span>
                ) : (
                  <>
                    <CopyButton value={`Hey! Enjoy this gift card 🎁 & have fun ❤️ \nClaim by clicking on this link\n${window.location.origin}#giftcard=${giftcard.code}\nCode: ${giftcard.code}`} />
                    <Share2
                      className="text-primary cray-touch"
                      size={20}
                      onClick={() =>
                        share({
                          title: 'Cray Gift Card',
                          url: `${window.location.origin}#giftcard=${giftcard.code}`,
                          text: `Hey! Enjoy this gift card 🎁 & have fun ❤️ \nClaim by clicking on this link \nCode: ${giftcard.code}`,
                        })
                      }
                    />
                    <Button asChild variant="outline">
                      <Link to={`claim`} state={{ giftCardCode: giftcard.code }}>
                        Claim
                      </Link>
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default GiftCards
